import { ICombination } from '../../AssignResults/Context/AssignResults.context';

export const isScramble = ({
  format: {
    format: { prefix }
  }
}: ICombination) => prefix === 'scramble';
